export default "/images/table-edit.svg?d0cbd078606905fc23297a6436d7b0a4";